export const OPEN_STREET_MAPS_LINK = 'https://tile.openstreetmap.org';
